import selfMsgBox from './src/main.js'
window._selfMsgBox = selfMsgBox
export default selfMsgBox
